var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "container" },
    [
      _c(
        "a-modal",
        {
          staticStyle: { top: "5%", height: "90%" },
          attrs: {
            title: _vm.title,
            width: _vm.width,
            visible: _vm.visible,
            confirmLoading: _vm.confirmLoading,
            getContainer: () => _vm.$refs.container,
            maskStyle: { top: "93px", left: "154px" },
            wrapClassName: _vm.wrapClassNameInfo(),
            mask: _vm.isDesktop(),
            maskClosable: false,
            cancelText: "取消",
            okText: "保存",
          },
          on: { cancel: _vm.handleCancel },
        },
        [
          _c(
            "template",
            { slot: "footer" },
            [
              _c("a-button", { key: "back", on: { click: _vm.handleCancel } }, [
                _vm._v("\n        取消\n      "),
              ]),
            ],
            1
          ),
          _c(
            "a-spin",
            { attrs: { spinning: _vm.confirmLoading } },
            [
              _c(
                "a-col",
                { attrs: { md: 10, sm: 24 } },
                [
                  [
                    _c("a-tree", {
                      attrs: {
                        multiple: "",
                        selectedKeys: _vm.selectedKeys,
                        checkedKeys: _vm.checkedKeys,
                        treeData: _vm.roleFunctionTree,
                        checkStrictly: _vm.checkStrictly,
                        expandedKeys: _vm.iExpandedKeys,
                        autoExpandParent: true,
                      },
                      on: { select: _vm.onSelect },
                    }),
                  ],
                ],
                2
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }